export default "__VITE_ASSET__0e9ad42f__"